import * as React from 'react'
import { useState, useRef, useLayoutEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setIsLeavingPage } from '../../store/common/commonSlice'
import { useLocation } from 'react-router-dom'

import './grid.sass'

type Props = {
    items: React.ReactElement[]
}

const Grid: React.FunctionComponent<Props> = ({ items }: Props) => {
    const location = useLocation()
    const dispatch = useDispatch()

    const grid = useRef<HTMLDivElement>(null)
    const [loaded, setLoaded] = useState(true)

    const isNecessaryToSaveThePosition = () => {
        const adressLastItem = location.pathname.split('/').reverse()[0]
        return adressLastItem === '' || adressLastItem === 'membres' || location.pathname.includes('tags')
    }

    const resizeGridItem = (item: HTMLElement): void => {
        // @ts-ignore
        const rowGap = parseInt(window.getComputedStyle(grid.current).getPropertyValue('grid-row-gap'), 10)
        // @ts-ignore
        const rowHeight = parseInt(window.getComputedStyle(grid.current).getPropertyValue('grid-auto-rows'), 10)
        const rowSpan = Math.ceil(
            // @ts-ignore
            (item.querySelector('.itemContent').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap)
        )
        item.style.gridRowEnd = `span ${rowSpan}` // eslint-disable-line
    }

    useLayoutEffect(() => {
        let loadedCount = 0
        // @ts-ignore
        const images = Array.from(grid.current.getElementsByTagName('img'))

        const resizeAllGridItems = (): void => {
            setLoaded(false)
            // @ts-ignore
            const allItems = grid.current ? Array.from(grid.current.getElementsByClassName('grid__item')) : null

            if (grid.current) {
                allItems.forEach((item: HTMLElement) => {
                    resizeGridItem(item)
                })
            }

            setLoaded(true)
        }

        const imageLoaded = () => {
            loadedCount = loadedCount + 1
            if (loadedCount === images.length) {
                setLoaded(true)
                resizeAllGridItems()
            }
        }

        images.forEach((image) => {
            if (image.complete) {
                imageLoaded()
            } else {
                image.onload = () => imageLoaded()
            }
        })

        window.addEventListener('resize', resizeAllGridItems)
        setTimeout(() => {
            if (grid.current) resizeAllGridItems()
        }, 100)
        return () => {
            window.removeEventListener('resize', resizeAllGridItems)
        }
    }, [items])

    return (
        <div
            ref={grid}
            className={loaded ? 'grid grid_loaded' : 'grid'}
            style={{ display: 'grid', gridColumnGap: '8px', margin: '20px 0' }}
        >
            {items.map((item, idx) => (
                <div className="grid__item" key={idx}>
                    <div
                        className="grid__itemWrapper itemContent"
                        onClick={() => {
                            if (isNecessaryToSaveThePosition()) dispatch(setIsLeavingPage(true))
                        }}
                    >
                        {item}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Grid
